import { Button, Flex, Text } from '@chakra-ui/react'

import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import GlucoseTable from './GlucoseTable'

import Layout from 'components/ManagerLayout'
import { Link } from 'react-router-dom'

interface Props {
    highRisk: boolean
}

const Glucose = () => {
    return (
        <Layout>
            <Card>
                <CardHeader>
                    <Flex w="full" justifyContent="space-between" alignItems="center">
                        <Text>Monitoramento de Glicemia</Text>
                    </Flex>
                </CardHeader>
                <CardBody>
                    <GlucoseTable />
                </CardBody>
            </Card>
        </Layout>
    )
}

export default Glucose